import { OffersTypesComponents } from '@affiliate-cabinet/types'

import { advertisersTranslationKeys } from '../translations/advertisersTranslationKeys'

export const unknownAdvertiser: OffersTypesComponents['schemas']['Advertiser'] & {
  'data-testid': string
  translationKey: string
  value: string
} = {
  'data-testid': `advertiser-item-1`,
  id: 1,
  name: 'unknown',
  alias: 'unknown',
  description: 'unknown',
  links: [],
  logo: '',
  platforms: [],
  regions: [],
  restrictionGrade: 0,
  shortDescription: 'unknown',
  theme: [],
  translationKey: advertisersTranslationKeys.advertiserXXX.replace('xxx', 'unknown'),
  value: '1',
  website: 'unknown',
}
